import { cva, type VariantProps } from "class-variance-authority";

export const tabsVariants = cva(["relative flex w-full"], {
  variants: {
    variant: {
      buttons: ["rounded-full overflow-hidden bg-[#141414]"],
    },
  },
  defaultVariants: {
    variant: "buttons",
  },
});

export type TabsVariantsProps = VariantProps<typeof tabsVariants>;

export const tabVariants = cva(
  [
    "relative select-none inline-flex justify-center cursor-pointer items-center outline-hidden transition whitespace-nowrap",
  ],
  {
    variants: {
      variant: {
        default: ["text-mistBlue gap-x-2 pb-3 text-sm"],
        buttons: [
          "text-dawn-pink/30 w-full h-10 px-4 font-medium text-center text-sm leading-5.5 tracking-[0.4px]",
        ],
      },
      isActive: {
        false: null,
        true: null,
      },
      disabled: {
        false: null,
        true: null,
      },
    },

    compoundVariants: [
      {
        variant: "buttons",
        isActive: true,
        className: "text-white",
      },
    ],

    defaultVariants: {
      variant: "buttons",
    },
  }
);

export const activeElementVariants = cva("absolute", {
  variants: {
    variant: {
      buttons: "rounded-full bg-baltic-sea w-full h-full",
    },
  },
});

export type TabVariantsProps = VariantProps<typeof tabVariants>;
